import React from "react";
import "../../styles/AlternateAnswersField.css";

// Editable list of alternate accepted phrasings for a Text/Descriptive
// question's answer. Never shown to students — only the primary answer is
// displayed; these are additional strings that also grade as correct.
// Also used for the answers marked incorrect (rejectedAnswers), with its own
// wording.
const AlternateAnswersField = ({
  value = [], onChange,
  placeholder = "Another accepted way to write this answer…",
  addLabel = "+ Add alternate answer",
}) => {
  const handleChange = (idx, text) => {
    const next = [...value];
    next[idx] = text;
    onChange(next);
  };

  const handleRemove = (idx) => {
    onChange(value.filter((_, i) => i !== idx));
  };

  const handleAdd = () => {
    onChange([...value, ""]);
  };

  return (
    <div className="aaf-wrapper">
      {value.map((ans, idx) => (
        <div className="aaf-row" key={idx}>
          <input
            type="text"
            className="aaf-input"
            value={ans}
            placeholder={placeholder}
            onChange={(e) => handleChange(idx, e.target.value)}
          />
          <button
            type="button"
            className="aaf-remove-btn"
            onClick={() => handleRemove(idx)}
            aria-label="Remove answer"
          >
            ✕
          </button>
        </div>
      ))}
      <button type="button" className="aaf-add-btn" onClick={handleAdd}>
        {addLabel}
      </button>
    </div>
  );
};

export default AlternateAnswersField;
